export default {

  // 新增品控报告
  insertPaQcReport: '/ygsjzs/paQcReport/insertPaQcReport',
  // 修改品控报告
  updatePaQcReport: '/ygsjzs/paQcReport/updatePaQcReport',
  // 物理删除品控报告
  deleteDataPaQcReport: '/ygsjzs/paQcReport/deleteDataPaQcReport',
  // 查询品控报告详情
  selectPaQcReportByReportId: '/ygsjzs/paQcReport/selectPaQcReportByReportId',
  // 分页查询品控报告列表
  selectPaQcReportByPage: '/ygsjzs/paQcReport/selectPaQcReportByPage',
  // 导出品控报告
  exportPaQcReport: '/ygsjzs/paQcReport/exportPaQcReport'

}
